import { sxTable } from './sxProps';
import './styles.css'
import { Table, TableBody, TableContainer, TableHead, TableCell, TableRow, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TabelaReceitasProps } from '../../../interfaces/props/SaudeOnline/ReceitaDigital/TabelaReceitasProps';
import { capitalize } from '../../../utils/Capitalize';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

export default function TabelaReceitas(props: TabelaReceitasProps) {

    const accessibility = useAccessibility();

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
    ...{
        fontFamily: 'Unimed-Sans',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        color: '#4C4C4C'
    },
    ...accessibility.textStyleAccessibility,
    color: accessibility.contrastMode ? 'white' : '#4C4C4C'
    
    }));
      
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
          backgroundColor: '#F9F9F9'
      },
    }));

    return (
        <TableContainer className='container-table' sx={sxTable} style={accessibility.contrastBorderAccessibility} component={Paper}>
            <Table stickyHeader size="small">
                <TableHead>
                    <TableRow>
                        <StyledTableCell sx={{ width: '20%' }}><b>Data</b></StyledTableCell>
                        <StyledTableCell sx={{ width: '60%' }} align="left"><b>Solicitante</b></StyledTableCell>
                        <StyledTableCell sx={{ width: '20%' }} align="left"><b>Receita</b></StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.data.map((row) => (
                        <StyledTableRow
                            key={row.idAnexo}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <StyledTableCell component="th" scope="row">
                                {row.dtEmissao}
                            </StyledTableCell>
                            <StyledTableCell component="th" scope="row">
                                {capitalize(row.nomeSolicitante)}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                                <button 
                                    className='visualizar-receita-button' 
                                    onClick={()=> props.onVisualizarClicked(row.idAnexo)}
                                    style={{...accessibility.calculateFontStyle(14), ...accessibility.contrastColorAccessibility}}
                                    aria-label={`visualizar receita solicitada por ${row.nomeSolicitante}`}
                                >
                                    visualizar
                                </button>
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}